/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopePacketRecordingActionDto,
  ApiEnvelopePacketRecordingDto,
  ApiEnvelopePacketRecordingListDto,
  ApiEnvelopeVektorMonitorBotListDto,
  PacketRecordingAdminDownloadParams,
  PacketRecordingStartRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type packetRecordingAdminStartResponse200 = {
  data: ApiEnvelopePacketRecordingDto
  status: 200
}

export type packetRecordingAdminStartResponse401 = {
  data: ApiEnvelopePacketRecordingDto
  status: 401
}

export type packetRecordingAdminStartResponse404 = {
  data: ApiEnvelopePacketRecordingDto
  status: 404
}

export type packetRecordingAdminStartResponseSuccess = (packetRecordingAdminStartResponse200) & {
  headers: Headers;
};
export type packetRecordingAdminStartResponseError = (packetRecordingAdminStartResponse401 | packetRecordingAdminStartResponse404) & {
  headers: Headers;
};

export type packetRecordingAdminStartResponse = (packetRecordingAdminStartResponseSuccess | packetRecordingAdminStartResponseError)

export const getPacketRecordingAdminStartUrl = (botId: string,) => {




  return `/api/vektor/admin/packet-recordings/${botId}/start`
}

export const usePacketRecordingAdminStartHook = (): (botId: string,
    packetRecordingStartRequest?: PacketRecordingStartRequest, options?: RequestInit) => Promise<packetRecordingAdminStartResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    packetRecordingStartRequest?: PacketRecordingStartRequest, options?: RequestInit) => {

        return customFetcher(getPacketRecordingAdminStartUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(packetRecordingStartRequest)
  }
);
      }
  }


export type packetRecordingAdminStopResponse200 = {
  data: ApiEnvelopePacketRecordingActionDto
  status: 200
}

export type packetRecordingAdminStopResponse401 = {
  data: ApiEnvelopePacketRecordingActionDto
  status: 401
}

export type packetRecordingAdminStopResponse404 = {
  data: ApiEnvelopePacketRecordingActionDto
  status: 404
}

export type packetRecordingAdminStopResponseSuccess = (packetRecordingAdminStopResponse200) & {
  headers: Headers;
};
export type packetRecordingAdminStopResponseError = (packetRecordingAdminStopResponse401 | packetRecordingAdminStopResponse404) & {
  headers: Headers;
};

export type packetRecordingAdminStopResponse = (packetRecordingAdminStopResponseSuccess | packetRecordingAdminStopResponseError)

export const getPacketRecordingAdminStopUrl = (recordingId: string,) => {




  return `/api/vektor/admin/packet-recordings/${recordingId}/stop`
}

export const usePacketRecordingAdminStopHook = (): (recordingId: string, options?: RequestInit) => Promise<packetRecordingAdminStopResponse> => {

      const customFetcher = useSfetchMutator();
      return (recordingId: string, options?: RequestInit) => {

        return customFetcher(getPacketRecordingAdminStopUrl(recordingId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type packetRecordingAdminDeleteResponse200 = {
  data: ApiEnvelopePacketRecordingActionDto
  status: 200
}

export type packetRecordingAdminDeleteResponse401 = {
  data: ApiEnvelopePacketRecordingActionDto
  status: 401
}

export type packetRecordingAdminDeleteResponse404 = {
  data: ApiEnvelopePacketRecordingActionDto
  status: 404
}

export type packetRecordingAdminDeleteResponseSuccess = (packetRecordingAdminDeleteResponse200) & {
  headers: Headers;
};
export type packetRecordingAdminDeleteResponseError = (packetRecordingAdminDeleteResponse401 | packetRecordingAdminDeleteResponse404) & {
  headers: Headers;
};

export type packetRecordingAdminDeleteResponse = (packetRecordingAdminDeleteResponseSuccess | packetRecordingAdminDeleteResponseError)

export const getPacketRecordingAdminDeleteUrl = (recordingId: string,) => {




  return `/api/vektor/admin/packet-recordings/${recordingId}`
}

export const usePacketRecordingAdminDeleteHook = (): (recordingId: string, options?: RequestInit) => Promise<packetRecordingAdminDeleteResponse> => {

      const customFetcher = useSfetchMutator();
      return (recordingId: string, options?: RequestInit) => {

        return customFetcher(getPacketRecordingAdminDeleteUrl(recordingId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type packetRecordingAdminListResponse200 = {
  data: ApiEnvelopePacketRecordingListDto
  status: 200
}

export type packetRecordingAdminListResponse401 = {
  data: ApiEnvelopePacketRecordingListDto
  status: 401
}

export type packetRecordingAdminListResponseSuccess = (packetRecordingAdminListResponse200) & {
  headers: Headers;
};
export type packetRecordingAdminListResponseError = (packetRecordingAdminListResponse401) & {
  headers: Headers;
};

export type packetRecordingAdminListResponse = (packetRecordingAdminListResponseSuccess | packetRecordingAdminListResponseError)

export const getPacketRecordingAdminListUrl = () => {




  return `/api/vektor/admin/packet-recordings`
}

export const usePacketRecordingAdminListHook = (): ( options?: RequestInit) => Promise<packetRecordingAdminListResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getPacketRecordingAdminListUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type packetRecordingAdminListRecordableBotsResponse200 = {
  data: ApiEnvelopeVektorMonitorBotListDto
  status: 200
}

export type packetRecordingAdminListRecordableBotsResponse401 = {
  data: ApiEnvelopeVektorMonitorBotListDto
  status: 401
}

export type packetRecordingAdminListRecordableBotsResponseSuccess = (packetRecordingAdminListRecordableBotsResponse200) & {
  headers: Headers;
};
export type packetRecordingAdminListRecordableBotsResponseError = (packetRecordingAdminListRecordableBotsResponse401) & {
  headers: Headers;
};

export type packetRecordingAdminListRecordableBotsResponse = (packetRecordingAdminListRecordableBotsResponseSuccess | packetRecordingAdminListRecordableBotsResponseError)

export const getPacketRecordingAdminListRecordableBotsUrl = () => {




  return `/api/vektor/admin/packet-recordings/bots`
}

export const usePacketRecordingAdminListRecordableBotsHook = (): ( options?: RequestInit) => Promise<packetRecordingAdminListRecordableBotsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getPacketRecordingAdminListRecordableBotsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type packetRecordingAdminDownloadResponse200 = {
  data: Blob
  status: 200
}

export type packetRecordingAdminDownloadResponseSuccess = (packetRecordingAdminDownloadResponse200) & {
  headers: Headers;
};
;

export type packetRecordingAdminDownloadResponse = (packetRecordingAdminDownloadResponseSuccess)

export const getPacketRecordingAdminDownloadUrl = (recordingId: string,
    params?: PacketRecordingAdminDownloadParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/vektor/admin/packet-recordings/${recordingId}/download?${stringifiedParams}` : `/api/vektor/admin/packet-recordings/${recordingId}/download`
}

export const usePacketRecordingAdminDownloadHook = (): (recordingId: string,
    params?: PacketRecordingAdminDownloadParams, options?: RequestInit) => Promise<packetRecordingAdminDownloadResponse> => {

      const customFetcher = useSfetchMutator();
      return (recordingId: string,
    params?: PacketRecordingAdminDownloadParams, options?: RequestInit) => {

        return customFetcher(getPacketRecordingAdminDownloadUrl(recordingId,params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


